import { render, staticRenderFns } from "./ResendNotificationButton.vue?vue&type=template&id=b5c41db6"
import script from "./ResendNotificationButton.vue?vue&type=script&lang=js"
export * from "./ResendNotificationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports